/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.giant_links.init());

App.giant_links = {
  init() {
    return $(document)
      .off('click', '.js-giant-link', App.giant_links.clicked)
      .on('click', '.js-giant-link', App.giant_links.clicked);
  },


  clicked(evt) {
    if (evt.target.tagName.toLowerCase() !== "a") { return location.href = $(this).data("url"); }
  }
};
